import React from 'react'
import PropTypes from 'prop-types'
import Button from 'components/common/Button/Button'

const AddToQuoteButton = ({ handleClick, disabled, ...props }) =>
  <Button
    { ...props }
    data-at-add-to-quote-btn
    disabled={ disabled }
    important
    full="mobile"
    onClick={ handleClick }>ADD & SCHEDULE
  </Button>

AddToQuoteButton.propTypes = {
  disabled: PropTypes.bool,
  handleClick: PropTypes.func
}

export default AddToQuoteButton
